import { useState, useEffect, useCallback, useMemo } from "react";
import { size_chart } from "../../reduxData/user/userAction";
import { delete_size_row } from "../../reduxData/user/userAction";
import FrontTable from "./FrontTable";
import CustomModal from "./CustomDublicateModal";

const Sizes = () => {
  
  const [api, setApi] = useState("");
  const [disableFields ,setDisableFields] = useState(false);
  const [editRow, setEditRow] = useState(false);
  const [disableCategory, setDisableCategory] = useState(false);

  const [frontTableData, setFrontTableData] = useState([]);
  const [apiCall, setApiCall] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState("");

  const [selectedGender, setSelectedGender] = useState("");

  const [selectedSizeRegion, setSelectedSizeRegion] = useState([]);

  const [selectedBrand, setSelectedBrand] = useState("");

  const [open, setOpen] = useState(false);
  const [defaultText, setDefaultText] = useState(false);

  const handleModalClose = () => {
    setOpen(false);
    setDefaultText(false);
    setDisableCategory(false);
    setEditRow("");
    setApi("");
  };

  const handleFrontPageChart = async () => {
    const res = await size_chart();

    setFrontTableData(res?.data);
    // console.log("front data ", res?.data);
  };

  const handleDeleteRow = async (i) => {
    const data = {
      gender_id: i?.gender_id,
      brand_id: i?.brand_id,
      type_id: i?.type_id,
    };
    const res = await delete_size_row(data);
    if (res) {
      handleFrontPageChart();
    }
  };

  useEffect(() => {
    handleFrontPageChart();
  }, [apiCall]);

  useEffect(() => {
    if (!selectedCategory) return;
    // handleGetSize();
  }, [selectedCategory, selectedBrand, selectedGender]);

  // console.log(selectedGender, selectedBrand,selectedCategory, "size chart ", sizeChartOfGender);

  useEffect(() => {
    if (
      selectedGender != null &&
      selectedGender !== "" &&
      selectedCategory != null &&
      selectedCategory !== "" &&
      selectedBrand != null &&
      selectedBrand !== ""
    ) {
      // setEditSizeId("");
      // setAddSizesLines([]);
    }
  }, [selectedGender, selectedCategory, selectedBrand]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  //console.log(selectedSizeRegion?.[0]?.map(i=>availableRegions?.find(ii=>ii?.id==i)))

  return (
    <div className="container add-product-wrapper  m-0 bg-white border border-2 rounded-3 py-3">
      <div className="row align-items-center">
        <div className="col-12 mx-auto ">
          <div
            className={`d-flex justify-content-end align-items-center size-all`}
          >
            <h3 className="fw-600 text-center mb-0">Size Chart</h3>
            <button
              className="btn btn-sm  btn-success rounded-3 fw-semibold"
              onClick={() => {
                setOpen(true);
                setApi("add");
                setEditRow(false);
                setDefaultText("Create a size chart");
                setDisableFields(false);
              }}
            >
              Add
            </button>
          </div>

          <FrontTable
            setApi={setApi}
            setEditRow={setEditRow}
            frontTableData={frontTableData}
            setSelectedGender={setSelectedGender}
            setSelectedSizeRegion={setSelectedSizeRegion}
            setSelectedCategory={setSelectedCategory}
            setSelectedBrand={setSelectedBrand}
            // setSelectedSizeCategory={setSelectedSizeCategory}
            // setNames={setNames}
            setOpen={setOpen}
            setDefaultText={setDefaultText}
            handleDeleteRow={handleDeleteRow}
            setDisableCategory={setDisableCategory}
            setDisableFields={setDisableFields}
          />
        </div>
      </div>
      {open && (
        <CustomModal
          open={open}
          setOpen={handleModalClose}
          Gender={selectedGender}
          Brand={selectedBrand}
          Category={selectedCategory}
          Region={selectedSizeRegion}
          setApiCall={setApiCall}
          defaultText={defaultText}
          setDefaultText={setDefaultText}
          frontTableData={frontTableData}
          frontSelectedBrand={setSelectedBrand}
          frontSelectedCategory={setSelectedCategory}
          frontSelectedGender={setSelectedGender}
          disableCategory={disableCategory}
          setDisableCategory={setDisableCategory}
          editRow={editRow}
          disableFields={disableFields}
          setEditRow={setEditRow}
          setApi={setApi}
          api={api}
        />
      )}
    </div>
  );
};

export default Sizes;
